<form [formGroup]="gewoneGiftenFg">
    <div *ngIf="gewoneGiften.length > 0">
        <div formArrayName="gewoneGiften">
            <div *ngFor="let item of gewoneGiften.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving gewone gift' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="omschrijving"
                                                id="omschrijvingGewoon"
                                                (change)="saveForm()"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Culture ANBI?' : ''"
                                                  [options]="optionsJaNee"
                                                  [required]=true
                                                  class="col-auto custom-input-150"
                                                  formControlName="cultureleAnbi"
                                                  id="cultureleAnbi-{{i}}"

                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  [required]=true
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedragGewoon"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijGewoneGiften(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKostenGewoon"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="gewoneGiften.length === 0">
    <snelstart-ui-button (click)="addRijGewoneGiften()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Gewone gift
    </snelstart-ui-button>
</div>
<div *ngIf="gewoneGiften.length > 0">
    <snelstart-ui-button (click)="addRijGewoneGiften()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Gewone gift toevoegen
    </snelstart-ui-button>
</div>


<!--<div *ngIf="this.isDefAangifte">-->
<!--    <form [formGroup]="gewoneGiftenFg">-->
<!--        <snelstart-ui-alert type="info" [showIcon]="false">-->
<!--            <div class="row">-->
<!--                <p class="pt-2 ps-3">Vul de naam en/of vestigingsplaats van de ANBI in en start zoeken. Selecteer daarna een gewone of periodieke gift.</p>-->
<!--                <snelstart-ui-text-form-control id="zoekveld"-->
<!--                                                [label]="'Naam ANBI'"-->
<!--                                                formControlName="zoekWaardeNaam"-->
<!--                                                class="custom-input-250 ps-3"-->
<!--                                                (change)="searchAnbi()">-->
<!--                </snelstart-ui-text-form-control>-->
<!--                <snelstart-ui-text-form-control id="zoekveld2"-->
<!--                                                [label]="'Vestigingsplaats'"-->
<!--                                                formControlName="zoekWaardePlaats"-->
<!--                                                class="custom-input-250"-->
<!--                                                (change)="searchAnbi()">-->
<!--                </snelstart-ui-text-form-control>-->

<!--                <div-->
<!--                        *ngIf="!gewoneGiftenFg.get('zoekWaardeNaam')?.value && !gewoneGiftenFg.get('zoekWaardePlaats')?.value">-->
<!--                    <snelstart-ui-button type="primary"-->
<!--                                         class="custom-input-150 pt-3"-->
<!--                                         [disabled]="true"-->
<!--                                         (click)="tonenSpinner()">-->
<!--                        Zoek-->
<!--                    </snelstart-ui-button>-->
<!--                </div>-->
<!--                <div-->
<!--                        *ngIf="gewoneGiftenFg.get('zoekWaardeNaam')?.value || gewoneGiftenFg.get('zoekWaardePlaats')?.value">-->
<!--                    <snelstart-ui-button type="primary"-->
<!--                                         class="custom-input-150 pt-3"-->
<!--                                         (click)="tonenSpinner()">-->
<!--                        Zoek-->
<!--                    </snelstart-ui-button>-->

<!--                </div>-->


<!--            </div>-->
<!--            <div class="row pb-1">-->

<!--                <div *ngIf="showSearchSpinner" class="pt-2">-->
<!--                    <snelstart-ui-spinner></snelstart-ui-spinner>-->
<!--                </div>-->

<!--                <div *ngIf="!showSearchSpinner && showResult && (gewoneGiftenFg.get('zoekWaardeNaam')?.value || gewoneGiftenFg.get('zoekWaardePlaats')?.value)">-->
<!--                    <div *ngIf="resultCount > 0" class="mt-2">-->
<!--                        <div class="d-flex text-left">-->
<!--                            <p class="ps-1">Er zijn {{ resultCount }} ANBI's gevonden.-->
<!--                                <br/><br/>-->
<!--                                Selecteer onderstaand bij 'Gewone gift' of 'Periodieke gift' de-->
<!--                                juiste ANBI en vul het bedrag in.</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div *ngIf="resultCount < 1" class="mt-2">-->
<!--                        <div class="d-flex text-left">-->
<!--                            <p class="ps-1">Er zijn geen resultaten gevonden. Probeer het opnieuw.</p>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->
<!--        </snelstart-ui-alert>-->

<!--        <div class="row">-->
<!--            <div formArrayName="gewoneGiften">-->
<!--                <div *ngFor="let item of gewoneGiften.controls; let i = index; "-->
<!--                              [formGroupName]="i">-->
<!--                    <div>-->

<!--                        <div *ngIf="item.get('omschrijving')?.value === null && searchPerformed">-->
<!--                            <snelstart-ui-select-form-control-->
<!--                                    [label]="i === 0 ? 'Selecteer ANBI' : ''"-->
<!--                                    formControlName="omschrijving"-->
<!--                                    [options]="anbiOptionsNaam"-->
<!--                                    class="custom-input-250"-->
<!--                                    (change)="saveForm()"-->
<!--                            >-->

<!--                            </snelstart-ui-select-form-control>-->
<!--                        </div>-->

<!--                        <div *ngIf="item.get('omschrijving')?.value !== null">-->
<!--                            <label *ngIf="i === 0">Omschrijving gewone gift</label>-->
<!--                            <div *ngIf="i === 0" class="col d-flex align-items-center omschrijving1 me-1"-->
<!--                                    style="border-bottom-style: double;">-->
<!--                                {{ capitalizeWords(item.get('omschrijving')?.value) }}-->
<!--                            </div>-->
<!--                            <div *ngIf="i > 0" class="col d-flex align-items-center omschrijving2 me-1"-->
<!--                                 style="border-bottom-style: double;">-->
<!--                                {{ capitalizeWords(item.get('omschrijving')?.value) }}-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <snelstart-ui-number-form-control formControlName="bedrag"-->
<!--                                                          id="bedrag"-->
<!--                                                          [label]="i === 0 ? 'Bedrag' : ''"-->
<!--                                                          class="custom-input-150"-->
<!--                                                          [decimals]="0"-->
<!--                                                          align="right"-->
<!--                                                          prefix="€"-->
<!--                                                          [required]=true-->
<!--                                                          (change)="saveForm()"-->
<!--                                                          *ngIf="item.get('omschrijving')?.value !== null"-->
<!--                        >-->
<!--                        </snelstart-ui-number-form-control>-->
<!--                        <snelstart-ui-button id="buttonDeleteKosten"-->
<!--                                                    type="secondary"-->
<!--                                                    size="medium"-->
<!--                                                    iconType="light"-->
<!--                                                    (click)="verwijderRijGewoneGiften(i)"-->
<!--                                                    [class]="i === 0 ? 'firstrowbutton' : ''"-->
<!--                                                    *ngIf="item.get('omschrijving')?.value !== null"-->
<!--                        >-->
<!--                        </snelstart-ui-button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--    </form>-->

<!--    <div *ngIf="gewoneGiften.length === 0">-->
<!--        <div *ngIf="resultCount <= 0">-->
<!--        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus" [disabled]="true"-->
<!--                            >Gewone gift-->
<!--        </snelstart-ui-button>-->
<!--        </div>-->
<!--        <div *ngIf="resultCount > 0">-->
<!--        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"-->
<!--                             (click)="addRijGewoneGiften()">Gewone gift-->
<!--        </snelstart-ui-button>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div *ngIf="gewoneGiften.length > 0">-->
<!--        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"-->
<!--                             (click)="addRijGewoneGiften()">Gewone gift toevoegen-->
<!--        </snelstart-ui-button>-->
<!--    </div>-->

<!--</div>-->
